const article = {
    id: 'bulk-sku-requests',
    title: 'Bulk SKU requests',
    summary: 'Select several SKUs and raise one request for all of them. Reshoot warns you if the box is already audited or outbounded.',
    publishedAt: '2026-09-11',
    tags: ['skus', 'requests'],
    sections: [
        {
            type: 'paragraph',
            text: 'On Skus you can tick more than one row and raise a request for the whole selection. SKUs that already have an open request cannot be selected. A reshoot, or a preset change that needs a reshoot, tells you when the outbound box is audited or already outbounded.',
        },
        { type: 'heading', text: 'When to use' },
        {
            type: 'paragraph',
            text: 'Use bulk raise when the same request applies to many SKUs. Read the callback note before confirming a reshoot on a box that has left the floor.',
        },
        { type: 'heading', text: 'How to use' },
        {
            type: 'steps',
            items: [
                'Open Skus and select the rows you need. Rows with an open request stay disabled.',
                'Click Raise Request. The button shows how many SKUs are selected.',
                'Pick the request type and fill in the details.',
                'If the note says the box is audited, confirming creates a callback. If it is already outbounded, the request is a client-side callback.',
                'Confirm. The button shows the SKU count.',
            ],
        },
    ],
};

export default article;
